/** 운영 문서 §09.7의 이벤트·props 화이트리스트. 값은 enum/집계값만 허용한다. */
const EVENT_PROPS = {
    app_opened: ['channel', 'isReturning', 'returnBucket'],
    pet_created: ['petCount', 'hasConditionTag'],
    record_saved: ['recordType', 'channel', 'viaNotification'],
    first_record_completed: ['secondsSinceFirstOpen', 'entry'],
    dose_logged: ['status', 'wasScheduled', 'latencySec'],
    adherence_computed: ['windowDays', 'givenRatePct'],
    srr_measured: ['mode', 'hasThreshold'],
    notification_permission: ['result'],
    notification_sent: ['channel', 'templateCode'],
    notification_opened: ['channel', 'templateCode'],
    report_started: ['rangeDays', 'blocksWithData'],
    report_generated: ['rangeDays', 'blocksWithData'],
    share_invited: [],
    share_accepted: [],
    handoff_created: ['delivery', 'selectedCount', 'remainingCount'],
    export_performed: ['format'],
    paywall_viewed: ['trigger', 'productId'],
    purchase_started: ['trigger', 'productId'],
    purchase_completed: ['trigger', 'productId'],
    error_shown: ['errorCode', 'screen'],
    cough_logged: ['slot', 'viaWidget'],
    gait_logged: ['kind', 'hasLimb', 'hasVideo'],
    resp_logged: ['eventType', 'hasDuration'],
    lab_saved: ['panel', 'itemCount', 'hasPhoto', 'entrySeconds'],
    meal_logged: ['foodType', 'deferredLeftover'],
    intake_completed: ['minutesSinceServed'],
    routine_completed: ['routineKind'],
    cost_logged: ['category'],
    widget_action: ['widgetKind', 'action'],
    memorial_opened: [],
    page_viewed: ['pageKind', 'slug', 'ref'],
    public_tool_used: ['tool'],
    public_to_app: ['tool'],
    share_completed: ['surface', 'channel'],
    purchase_intent: ['placement', 'channel'],
    week_closed: ['recordedDays', 'petCountBucket'],
    calendar_added: ['kind'],
    install_prompted: ['result'],
};
export const ANALYTICS_EVENT_PROPS = Object.fromEntries(Object.entries(EVENT_PROPS).map(([event, props]) => [event, [...props, 'traffic']]));
export function sanitizeAnalytics(event, props = {}) {
    if (!(event in ANALYTICS_EVENT_PROPS))
        return null;
    const key = event;
    const allowed = new Set(ANALYTICS_EVENT_PROPS[key]);
    const safeProps = Object.fromEntries(Object.entries(props).filter(([name]) => allowed.has(name)));
    return { event: key, props: safeProps };
}
